import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import WalletContextProvider from './contexts/WalletProviderContext';
import ConnectionProvider from './contexts/ConnectionProviderContext';
import TweetsProvider from "./contexts/TweetsContext";
import LikesProvider from './contexts/LikesContext';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <WalletContextProvider>
      <ConnectionProvider>
          <LikesProvider>
        <TweetsProvider>
            <App />
        </TweetsProvider>
          </LikesProvider>
      </ConnectionProvider>
    </WalletContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
